module.exports = "/images/vendor/flag-icon-css/flags/1x1/bj.svg?b6387659d755f8364b76c2bc8ca15d65";